import { AbstractTeamAttributeList } from "./AbstractTeamAttributeList";
export class TeamAttributeList extends AbstractTeamAttributeList {
  constructor(options: any) {
    super(options);
    this.initAttributesLists();
  }
}
